@if (show) {
  <mat-progress-bar class="global-progress-bar" [mode]="mode"></mat-progress-bar>
}
